'use strict';
var phoneValidation = require('./phoneValidation');

function getHtmlPattern(pattern) {
    if (!(pattern instanceof RegExp)) {
        return pattern;
    }
    return pattern.source.replace(/-/g, '\\-');
}
function enforcePatternValidationInclusion(ths) {
    var zipUsRegexPattern = '(^\\d{5}(-\\d{4})?$)';
    var zipRegexPattern = '(^(?:[a-zA-Z0-9]* ?[a-zA-Z0-9]*)$)';
    var emailRegexPattern = '^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$';
    var countryFieldRef = $('select[name=dwfrm_registration_country]');
    var accountPostalcodeFieldRef = $('input[name=dwfrm_registration_postalCode]');
    var billingPostalcodeFieldRef = $('input[name=dwfrm_billing_addressFields_postalCode]');

    var countryWhiteList = ['US', 'CA']; // To be moved to site preference if any additional changes countries will be added to whitelist
    var countryValue = "";
    var selectedCountry = $('.js-request-info-form select[name="Country"]').val();
    var phoneFieldRef = $('.js-request-info-form input[name="phonenumber"]');
    var phoneValue = phoneFieldRef.val() ? phoneFieldRef.val().trim() : '';
    if (phoneValue !== '' && selectedCountry !== '') {
        var validationResult = phoneValidation.validatePhoneNumber(phoneValue, selectedCountry);
        phoneFieldRef.attr('pattern', getHtmlPattern(validationResult.pattern.pattern));
    }
    if (countryFieldRef.length > 0) {
        countryValue = "" + countryFieldRef.val();
    }

    if (accountPostalcodeFieldRef.length > 0) {
        if (countryWhiteList.indexOf(countryValue.toUpperCase()) > -1) {
            if ((countryValue.toUpperCase()) === 'US') {
                accountPostalcodeFieldRef.attr('pattern', zipUsRegexPattern);
                accountPostalcodeFieldRef.attr('datapatt', countryValue.toUpperCase());
            }
        } else {
            accountPostalcodeFieldRef.attr('pattern', zipRegexPattern);
            accountPostalcodeFieldRef.removeAttr('datapatt');
        }
    }
    if (billingPostalcodeFieldRef.length > 0) {
        countryFieldRef = $('select[name=dwfrm_billing_addressFields_country]');
        if (countryFieldRef.length > 0) {
            countryValue = "" + countryFieldRef.val();
        }
        if (countryWhiteList.indexOf(countryValue.toUpperCase()) > -1) {
            billingPostalcodeFieldRef.attr('pattern', zipRegexPattern);
        } else {
            billingPostalcodeFieldRef.removeAttr('pattern');
        }
    }

    // Apply email pattern validation to all email input fields
    var emailFieldRef = $('input[type="email"]');
    if (emailFieldRef.length > 0) {
        emailFieldRef.attr('pattern', emailRegexPattern);
    }
}

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
    var valid = true;
    enforcePatternValidationInclusion(this);

    var validityResult = (this.checkValidity && !this.checkValidity());
    if (validityResult) {
        // safari
        valid = false;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        $(this).find('input, select').each(function () {
            if (!this.validity.valid) {
                $(this).trigger('invalid', this.validity);
            }
        });
    }
    return valid;
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearForm(form) {
    $(form).find('.form-control.is-invalid').removeClass('is-invalid');
}

module.exports = {
    invalid: function () {
        $('#address1').attr('data-missing-error', 'Please enter a billing address');
        $('#city').attr('data-missing-error', 'Please enter a city');
        $('#zipCode').attr('data-missing-error', 'Please enter a ZIP code');
        $('form input, form select').on('invalid', function (e) {
            e.preventDefault();
            if (!this.validity.valid) {
                var validationMessage = this.validationMessage;
                $(this).addClass('is-invalid');
                if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
                    validationMessage = $(this).data('pattern-mismatch');
                }
                if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if ((this.validity.tooLong || this.validity.tooShort)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if (this.validity.valueMissing && $(this).data('missing-error')) {
                    validationMessage = $(this).data('missing-error');
                    this.setCustomValidity(validationMessage);
                }
                // 119989
                if (this.validity.patternMismatch && $(this).data('pattern-mismatch') && (this.validity.tooLong || this.validity.tooShort) && $(this).data('range-error')) {
                    validationMessage = $(this).data('pattern-mismatch');
                }
                if (!this.validity.valueMissing && this.attributes.datapatt !== undefined && this.attributes.datapatt.nodeValue === 'US') {
                    validationMessage = 'Please enter a valid U.S. zip code.';
                }
                if ((this.validity.typeMismatch || this.validity.patternMismatch) && this.type === 'email') {
                    validationMessage = 'Please enter a valid email address.';
                }
                if (this.validity.patternMismatch && this.type === 'tel') {
                    validationMessage = 'Please enter a valid phone number.';
                }
                $(this).parents('.form-group').find('.invalid-feedback')
                    .text(validationMessage);
            }
        });
    },

    submit: function () {
        $('form').on('submit', function (e) {
            return validateForm.call(this, e);
        });
    },

    buttonClick: function () {
        $('form button[type="submit"], form input[type="submit"]').on('click', function () {
            // clear all errors when trying to submit the form
            clearForm($(this).parents('form'));
        });
    },
    /*
     * Story 29419 Unauthorized Access To Order
     * Displays an help text message when the input email box is focused or customer tries to change the email ID
     */
    onEmailChange: function () {
        $('#dwfrm_registration input[name="dwfrm_registration_email"]').focus(function () {
            var message = $(this).parents('.form-group').attr('data-emailchangemsg');
            $(this).addClass('is-invalid');
            $(this).parents('.form-group').find('.invalid-feedback').text(message); // #10-378120
        });
    },

    onBlur: function () {
        $('form input, form select').on('blur', function (e) {
            this.setCustomValidity('');
            // clear this specific error, then validate
            clearForm($(this).closest('.form-group'));
            return validateForm.call(this, e);
        });
        /*
         * Story 29419 Unauthorized Access To Order.
         * When customer enters email in the PI page during checkout, it is checked if a customer exists with the email given.
         * If customer exists, it will display a error message.
         * If customer doesn't exist, the flow will be continued.
         */
        $('#dwfrm_registration input[name="dwfrm_registration_email"]').blur(function () {
            if ($(this).val() !== '') {
                var url = $(this).parents('.form-group').attr('data-url');
                var currentEmail = $(this).val();
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'GET',
                    data: { currentEmail: currentEmail },
                    success: function (data) {
                        if (data.error === true) {
                            $('input#email').addClass('is-invalid');
                            $('input[name="dwfrm_registration_email"]').parents('.form-group').find('.invalid-feedback').html(data.message);
                        }
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    onCountryChange: function () {
        $('.js-request-info-form select[name="Country"]').on('change', function () {
            var selectedCountry = $(this).val();
            var phoneFieldRef = $('.js-request-info-form input[name="phonenumber"]');
            var phoneValue = phoneFieldRef.val() ? phoneFieldRef.val().trim() : '';
            var updatedPhoneNumber;
            if (phoneValue && selectedCountry) {
                var countryCode = phoneValidation.getCountryCode(selectedCountry);
                if (phoneValue.startsWith('+')) {
                    var phoneWithoutCode = phoneValue.replace(/^\+\d+[\s.-]?/, '');
                    updatedPhoneNumber = countryCode + ' ' + phoneWithoutCode;
                    phoneFieldRef.val(updatedPhoneNumber);
                } else {
                    updatedPhoneNumber = countryCode + ' ' + phoneValue;
                    phoneFieldRef.val(updatedPhoneNumber);
                }
                phoneFieldRef.data('country-code', countryCode);
                phoneFieldRef.attr('data-country-code', countryCode);
            }
        });
    },

    functions: {
        validateForm: function (form, event) {
            validateForm.call($(form), event || null);
        },
        clearForm: clearForm
    }
};
